import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                'select': 'changeLanguage'
            }
        }
    }

    changeLanguage() {
        window.location.href = this.$('select')[0].querySelector(`option[value="${this.$('select')[0].value}"]`).getAttribute('data-langswitcher-url')
    }
}
